<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
  _/                                                                                                                    _/
  _/      子画面定義：(STFMFM02C19ConfirmDeleteETF)  電子取引データのゴミ箱移動                                                _/
  _/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <div
    class="overlay"
    :class="[isETFDeleteConfirmShow ? showClass : hideClass]"
    id="popup-collectFileRegist"
    ref="content"
  >
    <div class="popup" style="width: 700px;">
      <div class="popup-head" >ごみ箱に移動</div>
      <div class="popup-body blue">
        <!-- ****  メッセージ表示領域 **** -->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''" style="padding-left:0px">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>

        <div class="mt-10px">
          選択したフォルダまたはファイルをごみ箱に移動します。よろしいですか？<br>※電子帳簿保存法上、完全に削除することはできません。
          <div>
            <br>
          </div>
        </div>
      </div>
      <div class="popup-foot blue">
        <div class="footer-btn">
          <div class="frm-btn-row">
            <div class="frm-item grow center">
              <button
                class="frm-btn strong large"
                @click="okBtnCliked"
                ref="refYesBtn"
                tabindex="1"
              >
                はい
              </button>
              <button
                class="frm-btn large"
                ref="disagreeButton"
                @click="canCelBtnClicked"
                @blur="onblur"
                tabindex="2"
              >
                いいえ
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import _ from "lodash";
import Common from "@/util/common";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { API_STFMFM02C19_ETFPutInTrash } from "@/api/Modules/FM02/STFMFM02C19.js";

export default {
  name: "STFMFM02C19ConfirmDeleteETF",
  components: {
    ErrorMessage,
  },
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
      errors: [],
      selectedFolderKeyList: [],
      selectedFileKeyList: [],
    };
  },
  props: {
    // 画面表示制御 true:表示、false：非表示
    isETFDeleteConfirmShow: {
      type: Boolean,
      required: true,
    },
    // 削除対象フォルダキーリスト(汎用クラスのフォルダキーの型)、フォルダ未選択時は空リストを設定
    folderKeyList: {
      type: Object,
      required: true,
    },
    // 削除対象ファイルキーリスト(汎用クラスのファイルキーの型)、ファイル未選択時は空リストを設定
    fileKeyList: {
      type: Object,
      required: true,
    },
    // ログインユーザ種別 true:達人ユーザ、false:事業者
    isTzuser: {
      type: Boolean,
      required: true,
    },
    // ログインユーザの機能利用権限[フォルダ・ファイルの操作【作成/編集/削除/移動/複写】  true:権限有、false:権限無
    fmFolderOperation: {
      type: Boolean,
      required: true,
    },
    // ログインユーザの機能利用権限[ファイルの操作【登録/編集/削除/移動/複写】  true:権限有、false:権限無
    fmFileOperation: {
      type: Boolean,
      required: true,
    },
  },
  computed: {

  },

  watch: {
    isETFDeleteConfirmShow: function(newVal) {
      if (newVal) {
        this.reset();
        this.selectedFolderKeyList = this.folderKeyList;
        this.selectedFileKeyList = this.fileKeyList;
        this.$nextTick(function() {
          this.initFocus();
        });
      }
      this.handleBodyScrollOnModalStateChange(newVal)
    },
  },
  methods: {
    ...mapMutations("businessModule", ["processDialogue","handleBodyScrollOnModalStateChange"]),

    onblur(e) {
      Common.onblur(e, this);
    },

    // **********************************************
    // * OKボタンをクリック
    // **********************************************
    okBtnCliked() {
      
      this.reset();
      
      this.processDialogue(true);

      let params = {
        FolderKeyList: this.selectedFolderKeyList,
        FileKeyList: this.selectedFileKeyList,
      };
      
      API_STFMFM02C19_ETFPutInTrash(params).then(
        async (response) => {
          if (response.result == "0000") {
            // 正常時
            this.$emit("agreeDeleteETFFile");
            this.reset();
          }
          else{
            //エラー時
            var errParaList = [];
            if(response.errorParaList != null && response.errorParaList.length > 0){
              errParaList = response.errorParaList;
            }
            
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, errParaList)
              )
            );
          }
          this.processDialogue(false);
        }
        
      );
    },
    // **********************************************
    // * キャンセルボタンをクリック
    // **********************************************
    canCelBtnClicked() {

      this.$emit("disagreeDeleteETFFile");
      this.reset();
    },
    // **********************************************
    // * リセット
    // **********************************************
    reset() {
      this.errors.splice(0);
    },
    // **********************************************
    // * 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.refYesBtn.focus();
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .frm-btn-row {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .frm-btn {
    margin-top: 5px;
  }

  .frm-btn+.frm-btn {
    margin-left: 0px;
  }
}
</style>